import React from 'react';
import Icon from './Icon';

/**
 * Cockpit Input — quiet field on translucent surface; rust focus ring.
 */
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  icon?: string;
  fieldSize?: 'sm' | 'md' | 'lg';
}

const heights = { sm: 'var(--control-sm)', md: 'var(--control-md)', lg: 'var(--control-lg)' };

export default function Input({ label, icon, fieldSize = 'md', type = 'text', style, ...rest }: InputProps) {
  const field = (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', width: '100%' }}>
      {icon ? (
        <Icon
          name={icon}
          size={15}
          style={{ position: 'absolute', left: '11px', color: 'var(--text-faint)', pointerEvents: 'none' }}
        />
      ) : null}
      <input
        type={type}
        className="ck-input"
        style={{
          width: '100%',
          height: heights[fieldSize],
          padding: icon ? '0 12px 0 34px' : '0 12px',
          background: 'var(--surface-input)',
          border: '1px solid var(--border-hairline)',
          borderRadius: 'var(--radius-sm)',
          fontFamily: 'var(--font-ui)',
          fontSize: fieldSize === 'sm' ? 'var(--text-sm)' : 'var(--text-base)',
          color: 'var(--text-body)',
          outline: 'none',
          transition: 'border-color var(--dur-base) var(--ease-out), background var(--dur-base) var(--ease-out)',
        }}
        onFocus={(e) => {
          e.target.style.borderColor = 'var(--border-focus)';
          e.target.style.background = 'var(--surface-raised)';
        }}
        onBlur={(e) => {
          e.target.style.borderColor = 'var(--border-hairline)';
          e.target.style.background = 'var(--surface-input)';
        }}
        {...rest}
      />
    </span>
  );
  if (!label) return field;
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%', ...style }}>
      <span className="t-eyebrow">{label}</span>
      {field}
    </label>
  );
}
